import { SubscriptionOrderStatus } from 'chaika-enums';
import type { SubscriptionOrderData } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';

/**
 * Бэкенд считает подписку по заказу действующей только при наличии активной подписки за ним
 * (CreateChatWithDoctorCommand), поэтому статуса `Active` мало — нужен и `subscriptionId`.
 */
export function isActivatedSubscriptionOrder(subscriptionOrder: SubscriptionOrderData): boolean {
    return subscriptionOrder.status === SubscriptionOrderStatus.Active && isDefined(subscriptionOrder.subscriptionId);
}
